export default "__VITE_ASSET__rMqETNZn__"